var current = document.querySelector("#currentSliderImage");
var thumb = document.querySelectorAll(".slider-nav img");
for(var i = 0; i < thumb.length; i++){
    thumb[i].addEventListener("click", changeGalery);
}

function changeGalery(e) {
    current.src = e.target.src;
    current.className += " fade-in";
    setTimeout(function() {
        current.className = current.className.replace(/\bfade-in\b/g, "");
    }, 500);
}

var purchaseConfig = [
{
        name: "One-Time Purchase",
        slogan: "",
        items: [
            {
                name: "Single Pack - You Save 20%",
                price: "£39.95",
                discountFrom: "WAS £49.95",
                link: "/links-cp/exit1.php"
            },
            {
                name: "Three Pack - You Save 30%",
                price: "£104.85",
                discountFrom: "WAS £149.85",
                link: "/links-cp/exit2.php"
            },
            {
                name: "Six Pack - You Save 40%",
                price: "£179.70",
                discountFrom: "WAS £299.70",
                link: "/links-cp/exit3.php"
            },
        ]
    },
    {
        name: "Subscribe & Save",
        slogan: "Save up to 50% OFF",
        items: [
            {
                name: "Single Pack - You Save 30%",
                price: "£34.95",
                pricePrefix: "/mo",
                discountFrom: "WAS £49.95",
                link: "/links-cp/exit4.php"
            },
            {
                name: "Three Pack - You Save 40%",
                price: "£89.85",
                pricePrefix: "/mo",
                discountFrom: "WAS £149.85",
                link: "/links-cp/exit5.php"
            },
            {
                name: "Six Pack - You Save 50%",
                price: "£149.70",
                pricePrefix: "/mo",
                discountFrom: "WAS £299.70",
                link: "/links-cp/exit6.php"
            },
        ]
    },
];

var cartOptions = document.querySelectorAll(".cart-option-type .cart-option-header");
var allCartBodies = document.querySelectorAll(".card-body");
for(var i = 0; i < cartOptions.length; i++){
    var config = purchaseConfig[i];
    cartOptions[i].querySelector(".option-heading").innerHTML=config.name;
    if (config.slogan) {
        cartOptions[i].querySelector(".subscribe-save_up").innerHTML=config.slogan;
    }
    var subElements = cartOptions[i].parentNode.querySelectorAll(".inner-option");
    for(var k = 0; k < subElements.length; k++){
        var li = subElements[k];
        li.querySelector(".option-name").innerHTML=config["items"][k].name;
        var price = config["items"][k].price;
        if (config["items"][k].pricePrefix) {
            price = price +""+config["items"][k].pricePrefix;
        }
        li.querySelector(".price-nr").innerHTML=price;
        li.querySelector(".radio-custom").setAttribute("data-price",config["items"][k].price);
        li.querySelector(".radio-custom").setAttribute("data-discount",config["items"][k].discountFrom);
        li.querySelector(".radio-custom").setAttribute("data-link",config["items"][k].link);
    }
    cartOptions[i].addEventListener("click", function (e){
        for(var j = 0; j < cartOptions.length; j++){
            cartOptions[j].className = cartOptions[j].className.replace(/\bactive\b/g, "");
        }
        this.className += " active";
        for(var z = 0; z < allCartBodies.length; z++){
            allCartBodies[z].style.display = "none";
        }
        this.parentElement.querySelector(".card-body").style.display = "block";
        this.parentElement.querySelector(".card-body").querySelectorAll("li")[1].click();
    });
}


var allOptionSelections = document.querySelectorAll(".body-list li");
for(var i = 0; i < allOptionSelections.length; i++){
    allOptionSelections[i].addEventListener("click", function (e){
        for(var j = 0; j < allOptionSelections.length; j++){
            allOptionSelections[j].className = allOptionSelections[j].className.replace(/\bactive\b/g, "");
        }
        this.className += " active";
        configureExit(this.querySelector("input"))
    });
}

function configureExit(item) {
    document.getElementById("original-price").innerHTML = item.getAttribute("data-discount");
    document.getElementById("current-price").innerHTML = item.getAttribute("data-price");
    var exitLinks = document.querySelectorAll(".exit-link");
    for(var j = 0; j < exitLinks.length; j++){
        exitLinks[j].setAttribute('href', item.getAttribute("data-link"));
    }
}


var radios = document.getElementsByName('radio-group2');
for (var i = 0, length = radios.length; i < length; i++) {
    if (radios[i].checked) {
        radios[i].click();
        break;
    }
}


document.getElementById("discount-popup").addEventListener("click", function (e) {
    document.getElementById("discount-popup").style.display = "none";
});

window.runIntros = true;

document.getElementById("poromotion-popup").addEventListener("click", function (e) {
    document.getElementById("poromotion-popup").style.display = "none";
    window.runIntros = false;
});

var clientNames = ["Joanne","Sarah","Charlotte","Steven","Rachel","Paul","Lee","Victoria","Robert","Jennifer","John","Thomas","Adam","Hayley","Benjamin","Katie","Mark","Lucy","Louise","Michelle","Gemma","Helen","Lisa","Rebecca","Andrew","Richard","Emma","Hannah","Laura","Natalie","Kelly","Nicola","Claire","Elizabeth","Samantha","Amy"];
var clientCities = ["London","Birmingham","Glasgow","Liverpool","Bristol","Manchester","Sheffield","Leeds","Edinburgh","Leicester","Coventry","Bradford","Cardiff","Belfast","Nottingham","Kingston","Newcastle","Stoke-on-Trent","Southampton","Derby","Portsmouth","Brighton","Plymouth","Northampton","Reading","Luton","Wolverhampton","Bolton","Aberdeen","Bournemouth"];
var productTypes = ["Three Jars","Single Jar", "Three Jars", "Single Jar", "Three Jars","Six Jars","Single Jar"];
function setClient(){
    document.getElementById("name-client").innerHTML = clientNames[Math.floor(Math.random() * clientNames.length)]+" in "+clientCities[Math.floor(Math.random() * clientCities.length)]+", Britain bought";
    document.getElementById("product-client").innerHTML = productTypes[Math.floor(Math.random() * productTypes.length)];
    document.getElementById("purchase-time").innerHTML = Math.ceil(Math.random() * 9);
}

function fadeIn(){
    var target = document.getElementById("poromotion-popup");
    target.className = target.className.replace(/\bfade-out-slow\b/g, "");
    target.className += " fade-in-slow";
}

function fadeOut(){
    var target = document.getElementById("poromotion-popup");
    target.className = target.className.replace(/\bfade-in-slow\b/g, "");
    target.className += " fade-out-slow";
}

function showPurchased(){
    if (window.runIntros) {
        setClient();
        setTimeout(fadeIn, 5000);
        setTimeout(fadeOut, 10000);
        setTimeout(showPurchased, 15000);
    }
}


/*Countdown */
function startTimer(duration, display) {
  var timer = duration, minutes, seconds;
  setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      display.textContent = minutes + " minutes " + seconds + " seconds";
      if (--timer < 0) {
          timer = duration;
      }
  }, 1000);
}

window.onload = function () {
  var fiveMinutes = 60 * 25,
  display = document.querySelector('#timer');
  startTimer(fiveMinutes, display);
  setTimeout(showPurchased,5000);
};

addEventListener("DOMContentLoaded", function() {
    document.querySelector('.click-onload').click();
});


function openTab(event, tabId) {
    var tabContents = document.getElementsByClassName('tell-tab-content');
    for (var i = 0; i < tabContents.length; i++) {
        tabContents[i].style.display = 'none';
    }

    var tabLinks = document.getElementsByClassName('tell-tab-link');
    for (var i = 0; i < tabLinks.length; i++) {
        tabLinks[i].classList.remove('active');
    }

    document.getElementById(tabId).style.display = 'flex';
    event.currentTarget.classList.add('active');
}
